import TimeData from './TimeData';

class RoomData {
    constructor({
        id = 0,
        times = [new TimeData({ id: 0 }), new TimeData({ id: 1 })],
        name = '',
        sdate = '',
        edate = '',
        price = 0,
    } = {}) {
        this.id = id;
        this.times = times;
        this.name = name;
        this.sdate = sdate;
        this.edate = edate;
        this.price = price;
    }
}

export default RoomData;
